import { useApi } from '@src/app/context/Api';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { isEmpty, isUndefined } from 'lodash';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: TrustedValueHistory
 *
 * Displays list of trusted record changes about the risk record.
 *
 * @param riskRecord
 * @returns {Element}
 * @constructor
 */
export function TrustedValueHistory({ riskRecord = {} }) {
  const eid = riskRecord?.eid;

  const { useApiQuery } = useApi('RiskRecord');

  const [ListTrustedValueHistory, { data, error, isFetching, isLoading }] = useApiQuery('ListTrustedValueHistory');

  return (
    <ErrorHandler location="src/widgets/RiskRecords/TrustedValueHistory/TrustedValueHistory.jsx">
      {!isUndefined(data?.content) || isEmpty(data?.content) ? (
        <Alert title="There is no trusted value history for this risk record." variant="info" />
      ) : (
        <Table
          error={error}
          isLoading={isLoading || isFetching}
          requestArgs={{ eid, page: 0, size: 25, sort: 'flipDate,desc' }}
          requestFunction={ListTrustedValueHistory}
          requestKey="ListTrustedValueHistory"
          rows={data?.content}
          totalPages={data?.totalPages || 1}
          totalRecords={data?.totalElements || 0}
        />
      )}
    </ErrorHandler>
  );
}
